import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from '../../../../../shared/utils/swal.util';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/services/auth/auth.service';
import { MunicipioService } from 'app/core/services/sai/core/municipio/municipio-service.service';
import { EstadoService } from 'app/core/services/sai/core/estado/estado-service.service';
import { Estado } from 'app/core/dtos/sai/core/estado';
import { Municipio } from 'app/core/dtos/sai/core/municipio';
import { Orgao } from 'app/core/dtos/sai/core/orgao';
import { OrgaoService } from 'app/core/services/sai/core/orgao/orgao-service.service';
import { filtrarOpcoes } from 'app/shared/utils/busca-select.util';

@Component({
  selector: 'app-change-orgao',
  standalone: false,
  templateUrl: './change-orgao.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './change-orgao.component.css'
})
export class ChangeOrgaoComponent implements OnInit {
  /** Filtra as opções pelo texto digitado na busca dentro do select. */
  readonly filtrarOpcoes = filtrarOpcoes;
  /** Texto digitado na busca dentro de cada select da tela. */
  buscaEstado = '';
  buscaMunicipio = '';
  buscaOrgao = '';

  trocaOrgaoForm!: UntypedFormGroup;
  estado: Estado[] = [];
  municipio: Municipio[] = [];
  orgao: Orgao[] = [];
  orgaoFiltrado: Orgao[] = [];

  codEstadoEst?: number;
  codMunicipioMun?: number;
  codOrgaoOrg?: number;

  constructor(
    public dialogRef: MatDialogRef<ChangeOrgaoComponent>,
    private readonly authService: AuthService,
    private readonly orgaoService: OrgaoService,
    private readonly fb: UntypedFormBuilder,
    private readonly router: Router
  ) {
  }

  ngOnInit(): void {
    this.getOrgao();
    this.trocaOrgaoForm = this.createContactForm();
  }
  formControl = new UntypedFormControl('', [
    Validators.required,
  ]);

  getOrgao() {
    Swal.fire({
      title: 'Carregando...',
      text: 'Por favor, aguarde enquanto os municipios são carregados.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.orgaoService.getOrgaosAtivos()
      .subscribe(
        {
          next: (response) => {
            this.orgao = response.data;
            this.getEstados();
            Swal.close();
          },
          error: (error) => {
          },
        });
  }

  getEstados() {
    const estadosMap = new Map();
    this.orgao.forEach((o: any) => {
      const estado = o.municipio?.estado;
      if (estado && !estadosMap.has(estado.codEstadoEst)) {
        estadosMap.set(estado.codEstadoEst, estado);
      }
    });
    this.estado = Array.from(estadosMap.values());
  }

  onEstadoChange() {
    const municipiosMap = new Map();
    this.orgao.forEach((o: any) => {
      const municipio = o.municipio;
      if (municipio?.estado?.codEstadoEst === this.codEstadoEst && !municipiosMap.has(municipio.codMunicipioMun)) {
        municipiosMap.set(municipio.codMunicipioMun, municipio);
      }
    });
    this.municipio = Array.from(municipiosMap.values());

    this.codMunicipioMun = 0;
    this.codOrgaoOrg = 0;
    this.orgaoFiltrado = [];
  }


  onMunicipioChange() {
    this.orgaoFiltrado = this.orgao.filter((o: any) => o.municipio.codMunicipioMun === this.codMunicipioMun);

    this.codOrgaoOrg = 0;
  }

  createContactForm(): UntypedFormGroup {
    return this.fb.group({
      codEstadoEst: [''],
      codMunicipioMun: [''],
      codOrgaoOrg: [''],
    });
  }
  submit() {
    // emppty stuff
  }
  onNoClick(): void {
    this.dialogRef.close();
  }


  confirmAdd() {
    Swal.fire({
      title: 'Carregando...',
      text: 'Por favor, aguarde enquanto alteramos o orgao.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.authService.changeOrgao(this.codOrgaoOrg!).subscribe({
      next: () => {
        this.dialogRef.close();
        Swal.close();

        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      },
      error: (ex) => {
        this.dialogRef.close(ex);
        Swal.close();
      }
    });
  }
}

